import { Component, Input } from '@angular/core';
import { TaskWebPropertiesService } from '@supoui/shared/components/task-web-modal/services/task-web-properties.service';
import { ServiceItemType } from '@supoui/shared/model/service-item-type';
import { PurposeOfTravelItemType } from '@supoui/shared/model/purpose-of-travel-item-type';
import { CauseItemType } from '@supoui/shared/model/cause-item-type';
import { CustomerProfiles } from '@supoui/shared/model/customerProfiles';
import { IApplicationCustomerProfile } from '@supoui/shared/model/application-customer-profile';

export enum DisplayTypeEnum {
  FORMATTED_TEXT
}

@Component({
    selector: 'app-task-web-properties',
    templateUrl: './task-web-properties.component.html',
    styleUrls: ['./task-web-properties.component.scss'],
    standalone: false
})
export class TaskWebPropertiesComponent {
  @Input() properties = {};
  @Input() ignoredProperties: string[] = [];
  @Input() showEmptyProperties = false;
  @Input() showNestedProperties = true;
  @Input() propertiesDisplayTypes: Record<string, DisplayTypeEnum> = {};

  @Input() serviceItemList: ServiceItemType[];
  @Input() purposeOfTravelItemList: PurposeOfTravelItemType[];
  @Input() causes: Map<string, CauseItemType[]>;
  @Input() customerProfiles: IApplicationCustomerProfile[];

  constructor(public taskWebPropertiesService: TaskWebPropertiesService) {}

  getPropertyDisplayType(key: string): DisplayTypeEnum {
    return <DisplayTypeEnum>(<unknown>key) && this.propertiesDisplayTypes && this.propertiesDisplayTypes[key];
  }

  get DisplayTypeEnum(): any {
    return DisplayTypeEnum;
  }
}
